module.exports = __webpack_public_path__ + "img/xhkjLogo.3b368607.png";